import React from 'react';
import './Labs.css';

export const LabsLoader = ({ message = 'Cargando laboratorios...' }) => {
  return (
    <div className="labs-loader">
      <div className="labs-loader-content">
        <div className="labs-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <h3>{message}</h3>
        <p>Conectando con el servidor...</p>
      </div>
    </div>
  );
};

export const LabsError = ({ error, onRetry }) => {
  return (
    <div className="labs-error">
      <div className="labs-error-content">
        <div className="error-icon">⚠️</div>
        <h3>Error al cargar laboratorios</h3>
        <p className="error-message">{error}</p>
        <div className="error-actions">
          {onRetry && (
            <button className="btn-primary" onClick={onRetry}>
              🔄 Reintentar
            </button>
          )}
        </div>
        <div className="troubleshooting">
          <h4>💡 Posibles soluciones:</h4>
          <ul>
            <li>Verifica tu conexión a internet</li>
            <li>El servidor puede estar iniciándose (espera 1-2 minutos)</li>
            <li>Recarga la página completa</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
